import { SetUpServiceData } from '@pages/AdditionalServices/containers/methods/basket/types';
import { HistoryServicesData } from '@pages/History/types';

/**
 * Раздел меню для расчета доп. услуг — id корневой директории
 */
export const getServicesSectionId = (services: HistoryServicesData): string | null => {
  const setUpService = (services.find((s: SetUpServiceData) => s?.IsSetupService) ??
    services[0]) as SetUpServiceData | undefined;
  const rootDirectoryId = setUpService?.ServicesPath?.['0']?.id;

  return rootDirectoryId !== undefined && rootDirectoryId !== null ? String(rootDirectoryId) : null;
};
